/**
 * Permet de nettoyer un objet qui aurait des valeurs falsy : [], undefined, null, -x, ...
 * La fonction est récursive
 * @param o l'objet à nettoyer
 * @returns l'objet nettoyé
 */
export function unvalidObjectValuesClearer<
  T extends { [key: string | number]: { [key: string]: unknown } | unknown },
>(
  o: T,
): {
  [key: string]: unknown;
} {
  for (const key in o) {
    if (Object.prototype.hasOwnProperty.call(o, key)) {
      const element = o[key];

      if (!element) delete o[key];

      if (typeof element === 'object')
        unvalidObjectValuesClearer(element as { [key: string]: unknown });
    }
  }

  return o;
}
